import React, { Component } from 'react';
import { Button, Form } from 'semantic-ui-react';
import { Editor, EditorState, RichUtils } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import 'draft-js/dist/Draft.css';
import RichEditor from '../Editor/RichEditor';
import FileUpload from './FileUpload';
import { GetData, PostData } from './../../api/Service';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import RichTextEditor from './../RichText/RichTextEditor';
class NewTender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category: '',
            headline: '',
            description: '',
            date1: '',
            date_opening: '',
            date_closing: '',
            editorState: '',
            upInfo: [],
            tempInfo: [],
            type: '',
            subtype: '',
            key: '',
            submit: '',
            tender_type: 'ASSAM ENGINEERING COLLEGE'
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);
    }

    componentDidMount() {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;

        let url = `api/upload/${key}/api_upload_key/tender/${user_id}`;
        GetData(url)
            .then((data) => {
                //console.log(data);
                this.setState({
                    type: data.type,
                    subtype: data.subtype,
                    key: data.key,
                    submit: data.submit
                })
            }

            );
    }

    onEditorChange(value){
        this.setState({
            editorState: value
        })
    }


    handleChange(e) {
        var state = {};
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    onNewUpload = (value) => {


        let arr = this.state.upInfo.concat(value.files.fileUpload);
        arr.map((el) => {
            let name = el.name;
            let ext_1 = name.split('.');
            let ext = ext_1[ext_1.length - 1];
            el['ext'] = ext
        }
        );
        //console.log(arr);
        this.setState({
            upInfo: arr
        });



    }

    onSubmit(e) {
        e.preventDefault();

        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;

        //console.log(stateToHTML(this.state.editorState.getCurrentContent()));
        //short out the data
        const ddes = {
            description: this.state.description,
            date_opening: this.state.date_opening,
            date_closing: this.state.date_closing,
            type: this.state.tender_type
        }
        const headline = this.state.headline;
        const description = this.state.description;
        const date1 = this.state.date1;
        const upInfo = this.state.upInfo;
        const longd = this.state.editorState;

        const data = {
            ctgy: '1',
            head: headline,
            desc: [ddes],
            upInfo: upInfo,
            msg: longd,
            cBy: user_id,
            date: date1,
            id: user_id
        }
        //console.log(data);

        var url = `api/insert/${key}/new/${this.state.submit}`;
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this._postData(url, data)
                },
                {
                    label: 'No',
                    onClick: () => window.location.reload()
                }
            ]
        })

        
    }


    _initialize() {
        window.location.reload();
        this.setState({
            category: '',
            headline: '',
            description: '',
            date1: '',
            editorState: '',
            upInfo: [],
            tempInfo: []
        });
    }


    _postData(url, data) {
        PostData(url, data)
            .then((data) => {
                //console.log(data);
                if (data.affectedRows === 1) {
                    confirmAlert({
                        title: 'Successfully Submitted',
                        message: 'Your news has been successfully posted',
                        buttons: [
                            {
                                label: 'Okay',
                                onClick: () => this._initialize()
                            }
                        ]
                    })
                } else {
                    confirmAlert({
                        title: 'Something Went Wrong',
                        message: 'Please Contact your administrator',
                        buttons: [
                            {
                                label: 'Okay',
                                onClick: () => this._initialize()
                            }
                        ]
                    })
                }
            });
    }



    render() {
        let uploadFiles = [];
        if (this.state.upInfo.length > 0) {
            let arr = this.state.upInfo;
            uploadFiles = arr.map((el, index) =>
                <li key={index}>{el.name}</li>
            )
        }
        return (
            <div>
                <h2>Add new Tender</h2>
                <Form onSubmit={this.onSubmit}>
                    <Form.Field>
                        <label>Type</label>
                        <select name="tender_type" onChange={this.handleChange} value={this.state.tender_type}>
                            <option value="ASSAM ENGINEERING COLLEGE">ASSAM ENGINEERING COLLEGE</option>
                            <option value="RUSA">RUSA Tender</option>
                            <option value="NEQIP">NEQIP Tender</option>
                            <option value="TEQIP">TEQIP Tender</option>
                            <option value="DEPARTMENTAL">Departmental Tender</option>
                        </select>
                    </Form.Field>
                    
                    <Form.Field>
                        <label>Date</label>
                        <input
                            type="date"
                            placeholder='Date'
                            name="date1"
                            value={this.state.date1}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>

                    <Form.Field>
                        <label>Opening Date</label>
                        <input
                            type="date"
                            placeholder='Date'
                            name="date_opening"
                            value={this.state.date_opening}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>

                    <Form.Field>
                        <label>Closing Date</label>
                        <input
                            type="date"
                            placeholder='Date'
                            name="date_closing"
                            value={this.state.date_closing}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Headline</label>
                        <input
                            name="headline"
                            placeholder='Headline'
                            value={this.state.headline}
                            onChange={this.handleChange}
                            required={true}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Short Description (Not more than 50 words)</label>
                        <textarea
                            name="description"
                            placeholder="Short description (Not more than 50 words)"
                            value={this.state.description}
                            onChange={this.handleChange}
                            required={true}
                            rows="5"
                        ></textarea>
                    </Form.Field>

                    <Form.Field>
                        <label>Detailed Description</label>
                        <div>

                            <RichTextEditor
                                onChange={this.onEditorChange}
                                placeholder="Type Something here"
                            />


                            {/* <RichEditor
                                editorState={this.state.editorState}
                                onChange={(editorState) => this.setState({ editorState })}
                                placeholder="You can write HTML here....."
                            /> */}
                        </div>

                    </Form.Field>
                    <ol className="file-list-show">
                        {uploadFiles}
                    </ol>
                    <br />
                    <Button type='submit'>Submit</Button>
                    <Button type='submit'>Preview</Button>

                </Form>


                <FileUpload onChange={this.onNewUpload.bind(this)} type={this.state.type} subtype={this.state.subtype} key_id={this.state.key} submit={this.state.submit} />
            </div>
        )
    }
}

export default NewTender;


// WEBPACK FOOTER //
// ./src/HomeComponents/Tender/NewTender.jsx